// This method handles backwards compatibility for existing Nurse Queue tickets
export const withDeprecatedOption = (options, selectedOption) => {
  if (!selectedOption.code) {
    return options;
  }

  if (options.some(option => option.code === selectedOption.code)) {
    return options;
  }

  return [...options, selectedOption];
};

export const categoriesForTicketType = (categories, ticketTypes, ticketTypeCode) => {
  const ticketType = ticketTypes.find(type => type.code === ticketTypeCode);

  if (!ticketType) {
    return [];
  }

  return categories.filter(category => ticketType.categories.includes(category.code));
};

export const dispositionsForCategory = (categories, ticketCategory) => {
  const category = categories.find(category => category.code === ticketCategory);

  if (!category) {
    return [];
  }

  return category.dispositions;
}